import Vue         from 'vue';
import VueMoment   from 'vue-moment';
import Vue2Filters from 'vue2-filters';

var Vue2FiltersConfig = {
    capitalize : {
        onlyFirstLetter : false
    },
    currency   : {
        symbol                      : 'R$',
        decimalDigits               : 2,
        thousandsSeparator          : '.',
        decimalSeparator            : ',',
        symbolOnLeft                : true,
        spaceBetweenAmountAndSymbol : true
    },
    pluralize  : {
        includeNumber : false
    },
    ordinal    : {
        includeNumber : false
    }
}

Vue.use(Vue2Filters, Vue2FiltersConfig);

Vue.use(VueMoment);
